import { cloneElement } from 'react';

import { useRouterActions } from 'react-resource-router';

type Props = {
  url: string | undefined;
  children: JSX.Element;
};

// ClientLinkWrapper wraps around clickable components and enforces
// client side navigation by appending router push logic to the onClick handler.
// The component only expects a single children element.
export const ClientLinkWrapper = ({ url, children }: Props) => {
  const { push } = useRouterActions();
  const userDefinedOnClick:
    | ((
        e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
      ) => void)
    | undefined = children.props.onClick;

  if (!url) {
    return children;
  }

  const handleClick = (
    e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => {
    // Call possible defined onClick function defined by child element
    userDefinedOnClick?.(e);

    if (!(e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      push(url);
    }
  };

  return cloneElement(children, { onClick: handleClick });
};
